/**
 * Backend services
 */
// The API gateway used by the morph-mapper application stack.
export const BACKEND_API = import.meta.env.BACKEND_API;
